// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3GM8D","type":"styles_type__g6O3H","choices":"styles_choices__17xRz"};